import ApiService from "../../../common/api.service";
import { router } from "../../../router";

export async function GetReturs({ commit }, option) {
  /**
   * option belum di pakai
   */
  try {
    ApiService.init("heroku");
    commit("GET_RETURS_REQUEST");
    ApiService.setHeader();
    // const _total = await ApiService.query("/returmanagement");
    const _response = await ApiService.query("/v1/retur/list", option);
    commit("GET_RETURS_SUCCESS", _response);
  } catch (error) {
    commit("GET_RETURS_ERROR", { result: error.message });
  }
}

export async function GetRetur({ commit }, params) {
  try {
    ApiService.init("heroku");
    commit("GET_RETUR_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get(
      `/v1/retur/detail/${params.oracleCustomerId}/${params.returId}`
    );
    commit("GET_RETUR_SUCCESS", _response);
  } catch (error) {
    commit("GET_RETUR_ERROR", { result: error.message });
  }
}

export async function UpdateRetur({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_RETUR_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/retur/update/" + form.returId + '/done');
    commit("EDIT_RETUR_SUCCESS", _response);
    router.go(-1);
  } catch (error) {
    commit("EDIT_RETUR_ERROR", { result: error.message });
  }
}